/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  HubspotConnection,
  HubspotConnectionRemovalResponse,
  HubspotGenericObject,
  HubspotPropertiesMetadataResponse,
  HubspotPropertiesMetadataResponses,
  HubspotUserMappings,
  MapObjectTypeArrayHubspotPropertyTypeOverride,
  MapString,
  OauthLocation,
  ObjectType,
  SearchQuery,
  SearchResponseHubspotGenericObject,
  SearchResponseSimpleUser,
  UserMappingsRequest,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "hubspot";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Get org Hubspot connection (internal)
   *
   * @tags connections
   * @name GetOrgHubspotConnectionInternal
   * @request GET:/v1/tenant/{tenantId}/connection
   * @secure
   */
  getOrgHubspotConnectionInternal = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      HubspotConnection,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/connection`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOrgHubspotConnectionInternal */
  getOrgHubspotConnectionInternalPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/connection`);

  /**
   * @description Delete org Hubspot connection (internal)
   *
   * @tags connections
   * @name DeleteOrgHubspotConnectionInternal
   * @request DELETE:/v1/tenant/{tenantId}/connection
   * @secure
   */
  deleteOrgHubspotConnectionInternal = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      HubspotConnectionRemovalResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/connection`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteOrgHubspotConnectionInternal */
  deleteOrgHubspotConnectionInternalPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/connection`);

  /**
   * @description Initiate org Hubspot OAuth
   *
   * @tags oauth
   * @name InitiateOrgHubspotOAuth
   * @request GET:/v1/tenant/{tenantId}/oauth/initiate
   * @secure
   */
  initiateOrgHubspotOAuth = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      OauthLocation,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/initiate`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for initiateOrgHubspotOAuth */
  initiateOrgHubspotOAuthPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/oauth/initiate`);

  /**
   * @description Complete Hubspot OAuth
   *
   * @tags oauth
   * @name CompleteHubspotOAuth
   * @request GET:/v1/public/oauth/callback
   */
  completeHubspotOAuth = (
    query: {
      /** @minLength 1 */
      code?: string;
      /** @minLength 1 */
      error?: string;
      /** @minLength 1 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
        }
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for completeHubspotOAuth */
  completeHubspotOAuthPathGetter = (query: {
    /** @minLength 1 */
    code?: string;
    /** @minLength 1 */
    error?: string;
    /** @minLength 1 */
    state: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);

  /**
   * No description
   *
   * @name GetHubspotObjectById
   * @request GET:/v1/tenant/{tenantId}/generic/{object_type}/{id}
   * @secure
   */
  getHubspotObjectById = (
    tenantId: string,
    objectType: ObjectType,
    id: string,
    query?: {
      /**
       * specifies which properties of queried object should be returned - format:
       *
       * [all,default,some:prop1,prop2,prop3]
       * @default "all"
       */
      properties?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      HubspotGenericObject,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/generic/${objectType}/${id}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getHubspotObjectById */
  getHubspotObjectByIdPathGetter = (
    tenantId: string,
    objectType: ObjectType,
    id: string,
    query?: {
      /**
       * specifies which properties of queried object should be returned - format:
       *
       * [all,default,some:prop1,prop2,prop3]
       * @default "all"
       */
      properties?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/generic/${objectType}/${id}`, query);

  /**
   * No description
   *
   * @name GetHubspotObjectUrl
   * @request GET:/v1/tenant/{tenantId}/generic/{object_type}/{id}/object-url
   * @secure
   */
  getHubspotObjectUrl = (tenantId: string, objectType: ObjectType, id: string, params: RequestParams = {}) =>
    this.request<
      string,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/generic/${objectType}/${id}/object-url`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getHubspotObjectUrl */
  getHubspotObjectUrlPathGetter = (tenantId: string, objectType: ObjectType, id: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/generic/${objectType}/${id}/object-url`);

  /**
   * No description
   *
   * @name SearchForGenericHubspotObjects
   * @request POST:/v1/tenant/{tenantId}/generic/{object_type}/search
   * @secure
   */
  searchForGenericHubspotObjects = (
    tenantId: string,
    objectType: ObjectType,
    data: SearchQuery,
    query?: {
      /**
       * specifies which properties of queried object should be returned - format:
       *
       * [all,default,some:prop1,prop2,prop3]
       * @default "all"
       */
      properties?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      SearchResponseHubspotGenericObject,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/generic/${objectType}/search`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for searchForGenericHubspotObjects */
  searchForGenericHubspotObjectsPathGetter = (
    tenantId: string,
    objectType: ObjectType,
    query?: {
      /**
       * specifies which properties of queried object should be returned - format:
       *
       * [all,default,some:prop1,prop2,prop3]
       * @default "all"
       */
      properties?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/generic/${objectType}/search`, query);

  /**
   * No description
   *
   * @name ListPropertiesForObjects
   * @request GET:/v1/tenant/{tenantId}/properties
   * @secure
   */
  listPropertiesForObjects = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      objectType: ObjectType[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      HubspotPropertiesMetadataResponses,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/properties`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listPropertiesForObjects */
  listPropertiesForObjectsPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      objectType: ObjectType[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/properties`, query);

  /**
   * No description
   *
   * @name ListPropertiesForTheObject
   * @request GET:/v1/tenant/{tenantId}/object-type/{objectType}/properties
   * @secure
   */
  listPropertiesForTheObject = (tenantId: string, objectType: ObjectType, params: RequestParams = {}) =>
    this.request<
      HubspotPropertiesMetadataResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/object-type/${objectType}/properties`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listPropertiesForTheObject */
  listPropertiesForTheObjectPathGetter = (tenantId: string, objectType: ObjectType) =>
    this.getServicePath(`/v1/tenant/${tenantId}/object-type/${objectType}/properties`);

  /**
   * No description
   *
   * @name ListPropertyTypeOverrides
   * @request GET:/v1/tenant/{tenantId}/property-type-override/list
   * @secure
   */
  listPropertyTypeOverrides = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      MapObjectTypeArrayHubspotPropertyTypeOverride,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/property-type-override/list`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listPropertyTypeOverrides */
  listPropertyTypeOverridesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/property-type-override/list`);

  /**
   * No description
   *
   * @name ForcePropertyMetadataSync
   * @request POST:/v1/tenant/{tenantId}/properties/sync
   * @secure
   */
  forcePropertyMetadataSync = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      object,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/properties/sync`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for forcePropertyMetadataSync */
  forcePropertyMetadataSyncPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/properties/sync`);

  /**
   * No description
   *
   * @name ListUserMappings
   * @request POST:/v1/tenant/{tenantId}/user-mapping/list
   * @secure
   */
  listUserMappings = (tenantId: string, data: UserMappingsRequest, params: RequestParams = {}) =>
    this.request<
      HubspotUserMappings,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-mapping/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listUserMappings */
  listUserMappingsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/user-mapping/list`);

  /**
   * No description
   *
   * @name ReplaceMappings
   * @request POST:/v1/tenant/{tenantId}/user-mapping/replace
   * @secure
   */
  replaceMappings = (tenantId: string, data: HubspotUserMappings, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-mapping/replace`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceMappings */
  replaceMappingsPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/user-mapping/replace`);

  /**
   * @description Remaps chili users to hubspot users. The input has a structure of { UserId -> UserMapping? }, when UserMapping is present, it will be inserted, when it is None, the record will be deleted. The client has to correctly construct UserMapping values by e.g. obtaining a list of existing mappings via the 'user-mapping/list' endpoint. For each record in the argument list, the system will find all records with either chili or hubspot id and delete it, and then will insert provided values.
   *
   * @name RemapUsers
   * @request POST:/v1/tenant/{tenantId}/user-mapping/associate
   * @secure
   */
  remapUsers = (tenantId: string, data: HubspotUserMappings, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-mapping/associate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for remapUsers */
  remapUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/user-mapping/associate`);

  /**
   * No description
   *
   * @name ListUsers
   * @request GET:/v1/tenant/{tenantId}/Users/list
   * @secure
   */
  listUsers = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SearchResponseSimpleUser,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/Users/list`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listUsers */
  listUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/Users/list`);

  /**
   * No description
   *
   * @name SearchUsers
   * @request POST:/v1/tenant/{tenantId}/Users/search
   * @secure
   */
  searchUsers = (tenantId: string, data: SearchQuery, params: RequestParams = {}) =>
    this.request<
      SearchResponseSimpleUser,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/Users/search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for searchUsers */
  searchUsersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/Users/search`);
}
